const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: 1,
    backgroundColor: theme.ModalBGColor
  },
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: 'bold',
    padding: `10px 32px`,
    fontSize: theme.headerTextFontSize
  },
  moduleContainer: {
    padding: 32,
    display: 'flex'
  },
  formContainer: {
    padding: '20px 20px 0px 20px'
  },
  formLabel: {
    fontWeight: 500,
    fontSize: theme.textFontSize,
    lineHeight: '19px',
    color: theme.iconColor,
    width: '30%',
    paddingRight: '10px'
  },

  formValue: {
    width: '100%',
    display: 'flex',
    direction: 'column',
    padding: '8px',
    '&>div': {
      flex: 1,
      width: '75%'
    }
  },

  root: {
    padding: '0px 8px 0px 0px;'
  },
  title: {
    color: theme.HeaderSelectedText
  },
  circularProgress: {
    color: theme.white
  },
  actionButton: {
    textTransform: 'none',
    minWidth: 120,
    '&$actionButtonDisabled': {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.8,
    },
    '&$actionOutlineDisabled': {
      borderColor: theme.iconColor,
      color: theme.iconColor
    }
  },
  actionButtonDisabled: {},
  actionOutlineDisabled: {},
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: '30px'
  },
  inputRoot: {
    '& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline':
      {
        borderColor: `${theme.iconColor}`
      }
  },
  inputFocused: {},
  inputDisabled: {},
  inputError: {},
  inputField: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: 'initial'
  },
  errorMessage: {
    padding: '10px 0px 10px 14px',
    color: theme.palette.error.main,
    fontSize: theme.textFontSize
  },

  errorMessageVisible: {
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
    marginTop: '8px',
    paddingLeft: '10px',
    marginBottom: '2px'
  },

  labelProps: {
    fontSize: theme.headerTextFontSize,
    backgroundColor: theme.gridBGColor,
    color: theme.iconColor,
    padding: '0px 4px 0px 4px'
  },
  filledLabel: {
    top: 4,
    left: 8,
    '&$shrink': {
      transform: 'translate(4px, 2px) scale(0.75)'
    }
  },
  shrink: {}
});

export default styles;
